<section class="documents-page" aria-labelledby="documents-title">
  <header class="page-heading">
    <div>
      <p class="eyebrow">Knowledge base</p>
      <h1 id="documents-title">Your documents</h1>
      <p>Give Serg a small, searchable library to think with.</p>
    </div>
    <label class="upload-button ds-button ds-button--primary">
      <input type="file" [attr.accept]="acceptedTypes" multiple (change)="uploadFiles($event)" [disabled]="isUploading" />
      {{ isUploading ? 'Reading...' : 'Upload documents or code files' }}
    </label>
  </header>

  <div class="strategy-section">
    <div>
      <span class="field-label">Retrieval strategy</span>
      <p class="field-help">Choose how matching context is found for chat.</p>
    </div>
    <div class="strategy-toggle" role="group" aria-label="Retrieval strategy">
      @for (strategy of strategies; track strategy) {
        <button type="button" [class.selected]="rag.strategy() === strategy" [disabled]="strategy === 'vector'" (click)="chooseStrategy(strategy)">
          {{ strategy === 'bm25' ? 'BM25' : 'Vector' }}
        </button>
      }
    </div>
  </div>

  @if (rag.strategy() === 'vector') {
    <p class="notice">Vector retrieval is ready for an embedding provider, but is not configured yet. BM25 is available now.</p>
  }
  @if (uploadError) { <p class="error-message" role="alert">{{ uploadError }}</p> }

  @if (rag.documents().length) {
    <div class="document-list">
      @for (document of rag.documents(); track document.id) {
        <article class="document-row">
          <div class="file-icon">{{ fileBadge(document.name) }}</div>
          <div class="document-info">
            <strong>{{ document.name }}</strong>
            <span>{{ formatBytes(document.size) }} · {{ document.chunks.length }} chunks</span>
          </div>
          <span class="index-status" [class.error]="document.status === 'error'">{{ document.status }}</span>
          <button class="row-action" type="button" (click)="rag.indexDocument(document.id)" aria-label="Re-index document">↻</button>
          <button class="row-action remove" type="button" (click)="rag.removeDocument(document.id)" aria-label="Remove document">×</button>
        </article>
      }
    </div>
    <button class="reindex-all" type="button" (click)="reindexDocuments()">Re-index all documents</button>
  } @else {
    <div class="empty-state">
      <span class="empty-icon">+</span>
      <h2>No documents yet</h2>
      <p>Upload documents, code, or text files to start building your knowledge base.</p>
    </div>
  }

  <!-- Keywords Section -->
  @if (keywords.length > 0) {
    <section class="keywords-section" aria-labelledby="keywords-title">
      <h2 id="keywords-title">Keywords</h2>
      <div class="keywords-container">
          @for (keyword of keywords; track keyword) {
            <button type="button" class="keyword-bubble" (click)="searchKeyword(keyword)">
              {{ keyword }}
            </button>
          }
      </div>
    </section>
  }
</section>
